import React, { useState, useEffect, useRef } from "react";
import { Row, Button, Col, Checkbox, Card, Input, Typography, Modal, Select, Drawer, Spin, message } from "antd";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  SearchOutlined,
  CloseSquareFilled,
  MergeCellsOutlined,
  ClockCircleOutlined,
  ExpandAltOutlined,
  CodeSandboxOutlined,
  BackwardFilled,
  BlockOutlined,
} from "@ant-design/icons";
import SearchIcon from "../../../../assets/images/searchIcon.svg";
import Calender from "../../../../assets/images/calender.svg";
import closeX from "../../../../assets/images/close-x.svg";
import "../restaurantStyle.css";
import dayjs from "dayjs";
import db from "../../../../database";
import { SyncData } from "./SyncData";
import TableFeatures from "./TableFeatures";
import MenuLayout from "../MenuLayout";
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../../../utils/getMultilingualText";
import OrderListComponent from "../OrderListComponent";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import { getOpenPreparedBillsForTable, PREPARED_BILL_TABLE_ACTION_MESSAGE } from "../../../../utils/preparedBillTableLock";
import { tracePreparedBill } from "../../../../utils/preparedBillRecovery";
import { PrintFailureBar } from "../../../../lib/printer/printFailureNotice";
const TableLayout = (props) => {
  // Synchronous guard for opening a table. `loading` is a prop driven by the
  // parent's setState, so it does not update in time to stop a second tap in
  // the same tick — and handleTable creates/loads the table's fbOrder, so a
  // double-tap can run that twice. The prop is still checked for the button UI.
  const openTableInFlightRef = useRef(false);
  const {
    handleAmount,
    handleCashPayment,
    manualDiscountRestaurant,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    restaurantSections,
    mainTableData,
    setMainTableData,
    handleTable,
    handleReserveTable,
    occupiedDataTablesData,
    reservedTablesData,
    userPreferences,
    setOcupiedTablesData,
    setReservedTablesData,
    showProducts,
    setShowProducts,
    categorieFlag,
    setCategorieFlag,
    addDefinedProductWithAddons,
    restaurantProductCategory,
    productsData,
    pickProduct,
    increaseProductQty,
    decreaseProductQty,
    deleteProduct,
    setDisplayCustomerSearch,
    handleVoid,
    setPaymentVisible,
    paymentVisible,
    cart,
    setCart,
    deleteCart,
    setKeyValue,
    handleOrder,
    tableCards,
    setTableCards,
    setProductsData,
    saleTypeProducts,
    setSaleTypeProducts,
    filteredPaymentMethods,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    requestPayment,
    setNumb,
    amount,
    setAmount,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    processOrder,
    tableList,
    setTableList,
    recordState,
    setRecardState,
    fireItems,
    setFireItems,
    fireMode,
    setFireMode,
    pendingFireItems,
    setPendingFireItems,
    handleCopyKOT,
    waitlistTab,
    setWaitlistTab,
    saveToWaitlist,
    validateWaitlistForm,
    waitlistForm,
    setWaitlistForm,
    waitlistErrors,
    setWaitlistErrors,
    waitlistList,
    setWaitlistList,
    getWaitlist,
    reservationList,
    setReservationList,
    errors,
    setErrors,
    onCancel,
    onConfirm,
    form,
    setForm,
    selectData,
    setSelectData,
    reserveModalOpen,
    setReserveModalOpen,
    drawerOpen,
    setDrawerOpen,
    loadReservations,
    waitlistDrawerOpen,
    setWaitlistDrawerOpen,
    loadWaitlistForUI,
    setReservationsBlank,
    reservationsBlank,
    mergeDrawerOpen,
    setMergeDrawerOpen,
    displayReserveTablesPopup,
    setDisplayReserveTablesPopup,
    handleReserveTableDetails,
    setNumberOfPersons,
    setGuestMobile,
    guestMobile,
    handleKeyvalue,
    setOederedData,
    handleDisplayOk,
    selectedProductId,
    setSelectedProductId,
    cancelKotItems,
    setCancelKotItems,
    addonSourceItem,
    setAddonSourceItem,
    showAddonsCustomizePopup,
    setShowAddonsCustomizePopUp,
    addonRepeatDisabled,
    setAddonRepeatDisabled,
    setDisplayAddOnSelection,
    displayAddOnSelection,
    selectedProduct,
    setSelectedProduct,
    setAddOnsList,
    addOnsList,
    handleAddOnModal,
    productSearchInput,
    setProductSearchInput,
    restaurantButtonLoading,
    setRestaurantButtonLoading,
    loading,
    setLoading,
    matchedRep,
  } = props;
  const [selectedFloor, setSelectedFloor] = useState({ value: "all", name: "All" });
  const [reservedButtonFlag, setReservedButtonFlag] = useState(false);
  const [selectedTable, setSelectedTable] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [currentTable, setCurrentTable] = useState({});
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const isMultilingual = process.env.REACT_APP_MULTILINGUAL === "true";
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const [isSearchDrawerOpen, setIsSearchDrawerOpen] = useState(false);

  // const currentDateTime = useState(dayjs(new Date()).format(userPreferences.dateFormat));

  const tableData = tableCards;
  const { Text } = Typography;
  const { t } = useTranslation();
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage") || process.env.REACT_APP_LANGUAGE || "English";
    i18n.changeLanguage(savedLanguage);
  }, []);

  useEffect(() => {
    // Update the current date and time every second
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long", // Full day name (e.g., Wednesday)
    day: "numeric", // Day of the month (e.g., 28)
    month: "long", // Full month name (e.g., June)
    year: "numeric", // Full year (e.g., 2023)
  })}`;

  const handleButtonClick = async (floor) => {
    let tempData = [];
    if (floor.name === "All") {
      // tempData.push(...mainTableData);
      const updatedTableData = await db.tableData.toArray();
      tempData.push(...updatedTableData);
      setSelectedFloor(floor);
    } else {
      const updatedTableData = await db.tableData.toArray();
      updatedTableData.map((e) => {
        if (e.cwrFbsectionId === floor.value) {
          tempData.push(e);
          setSelectedFloor(floor);
        }
      });
    }
    setTableCards(tempData);
  };

  const handleCancel = async (values) => {
    // BUG-2425: cancelling the table closes its session with no payment and no cancel sent
    // to CW, so an open prepared bill on it stayed completed and un-invoiced (HMRS/10854).
    const preparedBills = await getOpenPreparedBillsForTable(values?.cwrFbTableId, useCartStore.getState().cart);
    if (preparedBills.length > 0) {
      message.error(PREPARED_BILL_TABLE_ACTION_MESSAGE(preparedBills[0].documentno, "cancelled"));
      tracePreparedBill("cancel-table-blocked-prepared-bill", { flow: "table-layout", tableId: values?.cwrFbTableId, bills: preparedBills.map((b) => ({ sOrderID: b.sOrderID, documentno: b.documentno })) });
      return;
    }
    Modal.confirm({
      title: "This action will cancel the table.Do you wish to proceed?",
      cancelText: "No",
      okText: "Yes",
      okButtonProps: { style: { display: "inline-block" } },
      onOk: async () => {
        const table = await db.tableData.where("cwrFbTableId").equals(values.cwrFbTableId).first();
        if (table) {
          table.statusType = "OPN";
          table.guestName = "";
          table.color = "rgba(146, 144, 152, 0.5)";
          table.noOfPersons = "";
          table.guestType = "";
          table.referredBy = "";
          table.tableSync = "N";
          table.salesRepId = table.waiter;
          table.fbOrderSync = "N";
          table.lines = [];
          table.items = [];
          await db.tableData.put(table);
          SyncData(table, "upsertTableStatus");
          setCurrentTable(table);
          const updatedTableData = await db.tableData.toArray();
          setTableCards(updatedTableData);
          setMainTableData(updatedTableData);
          const updatedOccupiedData = updatedTableData.filter((table) => table?.statusType === "OCU" || table.statusType === "ONG");
          setOcupiedTablesData(updatedOccupiedData);
          const updatedReservedData = updatedTableData.filter((table) => table.statusType === "RES");
          setReservedTablesData(updatedReservedData);

          let tempData = [];
          await db.tableData.toArray().then((fetched) => {
            tempData.push(...fetched);
          });
          setTableList(tempData);
        }
        await db.fbOrderData
          .where("cwrFbTableId")
          .equals(values?.cwrFbTableId)
          .toArray()
          .then(async (ordersFetched) => {
            if (ordersFetched.length > 0) {
              for (const fbOrder of ordersFetched) {
                if (fbOrder.fbOrderStatus === "IP") {
                  fbOrder.fbOrderStatus = "CL";
                  fbOrder.fbOrderSync = "N";
                  await db.fbOrderData.where("fbOrderId").equals(fbOrder.fbOrderId).modify({
                    fbOrderSync: "N",
                    fbOrderStatus: "CL",
                  });
                  await SyncData(fbOrder, "upsertFbOrder");
                }
              }
            }
          });
      },
    });
  };
  const handleLanguageChange = (value) => {
    i18n.changeLanguage(value);
    // document.body.dir = value === "Arabic" ? "rtl" : "ltr";
    localStorage.setItem("selectedLanguage", value);
  };

  // Map: tableId -> table object
  const tableById = {};
  tableData.forEach((t) => {
    tableById[t.cwrFbTableId] = t;
  });

  // Set of all child table IDs (that should be hidden)
  const mergedChildIds = new Set();
  const splitParentIds = new Set();
  const allDisplayTables = [];

  tableData.forEach((t) => {
    let merges = [];

    if (Array.isArray(t.merge)) {
      merges = t.merge;
    } else if (t.merge && typeof t.merge === "object") {
      // in case some old data stored a single object
      merges = [t.merge];
    } else if (t.merge && typeof t.merge === "string") {
      // in case it is stored as JSON string
      try {
        const parsed = JSON.parse(t.merge);
        if (Array.isArray(parsed)) merges = parsed;
        else if (parsed && typeof parsed === "object") merges = [parsed];
      } catch (e) {
        // ignore bad JSON
      }
    }

    // merges.forEach((m) => {
    //   if (m && m.fbMTableId) {
    //     mergedChildIds.add(m.fbMTableId);
    //   }
    // });
    merges.forEach((m) => {
      if (m && m.fbMTableId && m.fbMTableId !== t.cwrFbTableId) {
        mergedChildIds.add(m.fbMTableId);
      }
    });

    // Track split parent tables (we'll hide them)
    if (Array.isArray(t.splitTables) && t.splitTables.length > 0) {
      splitParentIds.add(t.cwrFbTableId);

      // Create virtual table objects for each split child
      t.splitTables.forEach((split, index) => {
        const virtualTable = {
          ...t,
          // Virtual split child properties
          id: `${t.cwrFbTableId}-split-${index}`,
          // cwrFbTableId: `${t.cwrFbTableId}-split-${index}`, // Unique ID for React key
          name: split.splitTable,
          displayName: split.splitTable,
          splitTable: split.splitTable,
          capacity: split.guests,
          statusType: split.status || "OPN",
          noOfPersons: 0,
          guestName: split.guestName || "",
          guestType: split.guestType || "",
          salesRepId: split.salesRepId || t.salesRepId,
          color: split.status === "ONG" || split.status === "OCU" ? "#ef476f" : split.status === "STD" ? "#fca311" : split.status === "RES" ? "#8338ec" : "#a7c957",
          isSplitChild: "Y",
          isSplitParent: "N",
          parentSplitTableId: t.cwrFbTableId,
          splitIndex: index,
        };
        allDisplayTables.push(virtualTable);
      });
    } else {
      // Add regular table to display
      allDisplayTables.push(t);
    }
  });

  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => {
      setNow(Date.now());
    }, 1000); // tick every second

    return () => clearInterval(id);
  }, []);

  const formatElapsed = (start) => {
    if (!start) return "";
    const diffMs = Date.now() - new Date(start).getTime();
    if (diffMs < 0) return "00:00:00";

    const totalSec = Math.floor(diffMs / 1000);
    const h = String(Math.floor(totalSec / 3600)).padStart(2, "0");
    const m = String(Math.floor((totalSec % 3600) / 60)).padStart(2, "0");
    const s = String(totalSec % 60).padStart(2, "0");
    return `${h}:${m}`;
  };

  return (
    <>
      {showProducts ? (
        <MenuLayout
          {...props}
          {...{ setKeyValue, deleteCart, cart, userPreferences, handleCashPayment }}
          setProductsData={setProductsData}
          categorieFlag={categorieFlag}
          setCategorieFlag={setCategorieFlag}
          addDefinedProductWithAddons={addDefinedProductWithAddons}
          restaurantProductCategory={restaurantProductCategory}
          productsData={productsData}
          pickProduct={pickProduct}
          increaseProductQty={increaseProductQty}
          decreaseProductQty={decreaseProductQty}
          deleteProduct={deleteProduct}
          setDisplayCustomerSearch={setDisplayCustomerSearch}
          handleVoid={handleVoid}
          paymentVisible={paymentVisible}
          setPaymentVisible={setPaymentVisible}
          handleOrder={handleOrder}
          showProducts={showProducts}
          setShowProducts={setShowProducts}
          saleTypeProducts={saleTypeProducts}
          setSaleTypeProducts={setSaleTypeProducts}
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          setNumb={setNumb}
          requestPayment={requestPayment}
          amount={amount}
          setAmount={setAmount}
          showOrderCompleteFlag={showOrderCompleteFlag}
          setShowOrderCompleteFlag={setShowOrderCompleteFlag}
          processOrder={processOrder}
          manualDiscountRestaurant={manualDiscountRestaurant}
          handleAmount={handleAmount}
          recordState={recordState}
          setRecardState={setRecardState}
          handleCancel={handleCancel}
          mainTableData={mainTableData}
          setMainTableData={setMainTableData}
          setFireItems={setFireItems}
          fireItems={fireItems}
          fireMode={fireMode}
          setFireMode={setFireMode}
          pendingFireItems={pendingFireItems}
          setPendingFireItems={setPendingFireItems}
          handleCopyKOT={handleCopyKOT}
          setOederedData={setOederedData}
          handleDisplayOk={handleDisplayOk}
          selectedProductId={selectedProductId}
          setSelectedProductId={setSelectedProductId}
          addonSourceItem={addonSourceItem}
          setAddonSourceItem={setAddonSourceItem}
          showAddonsCustomizePopup={showAddonsCustomizePopup}
          setShowAddonsCustomizePopUp={setShowAddonsCustomizePopUp}
          addonRepeatDisabled={addonRepeatDisabled}
          setAddonRepeatDisabled={setAddonRepeatDisabled}
          setDisplayAddOnSelection={setDisplayAddOnSelection}
          displayAddOnSelection={displayAddOnSelection}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          setAddOnsList={setAddOnsList}
          addOnsList={addOnsList}
          handleAddOnModal={handleAddOnModal}
          productSearchInput={productSearchInput}
          setProductSearchInput={setProductSearchInput}
        />
      ) : paymentVisible ? (
        <OrderListComponent
          {...props}
          requestPayment={requestPayment}
          saleTypeProducts={saleTypeProducts}
          setsaleTypeProducts={setSaleTypeProducts}
          setMainTableData={setMainTableData}
          mainTableData={mainTableData}
          restaurantButtonLoading={restaurantButtonLoading}
          setRestaurantButtonLoading={setRestaurantButtonLoading}
        />
      ) : (
        <div className="dinein-screen-root" style={{ position: "relative", width: "100%", height: "100vh" }}>
          <Row
            gutter={0}
            className="dinein-header-row"
            style={{
              fontSize: "1vw",
              padding: "0 1vw",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #E0E0E0",
            }}
          >
            {/* LEFT: FLOORS */}
            <div className="dinein-floor-buttons" style={{ display: "flex", alignItems: "center", gap: "0.6vw", flexWrap: "nowrap" }}>
              {restaurantSections?.map((section) => (
                <Button className={`floor-button ${selectedFloor.name === section.name ? "selected" : ""}`} onClick={() => handleButtonClick(section)}>
                  {section.name}
                </Button>
              ))}
            </div>

            {/* RIGHT: DATE + MERGE ICON + SEARCH */}
            <div className="dinein-header-actions" style={{ display: "flex", alignItems: "center", gap: "1vw" }}>
              <div
                className="dinein-header-date"
                style={{
                  fontWeight: 500,
                  fontFamily: "Inter",
                  fontSize: "1.1em",
                  color: "#929098",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.4vw",
                  whiteSpace: "nowrap",
                }}
              >
                <img src={Calender} style={{ height: "2.2vh" }} />
                {formattedDateTime}
              </div>

              {/* MERGE/SPLIT ICON BUTTON */}
              <div
                className="dinein-icon-btn"
                onClick={() => setMergeDrawerOpen(true)}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  background: "#2F3856",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <BlockOutlined style={{ fontSize: 18, color: "white" }} />
              </div>

              {/* SEARCH ICON */}
              <div
                className="dinein-icon-btn"
                onClick={() => setIsSearchDrawerOpen(true)}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  background: "#2F3856",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 12,
                  cursor: "pointer",
                }}
              >
                <CodeSandboxOutlined style={{ fontSize: 20, color: "white" }} />
              </div>
            </div>
          </Row>

          {/* BUG-2570 v2: print failures (bill, KOT) at the top of the table grid */}
          <PrintFailureBar style={{ margin: "0 1vw 8px" }} />

          <div className="tables-container">
            <Scrollbars autoHide className="tables-scrollbar" style={{ height: "87vh" }}>
              <div className="table-grid-bottom-spacer" style={{ paddingBottom: "10vh" }}>
                <InfiniteScroll
                  dataLength={tableCards.length}
                  hasMore={true}
                  endMessage={
                    <p className="center">
                      <b>Yay! you have seen it all</b>
                    </p>
                  }
                  style={{ overflowX: "hidden" }}
                >
                  {/* <Row gutter={[16, 16]} style={{ rowGap: "11px" }}>
                    {[...tableData]
                      .sort((a, b) => {
                        const extractParts = (name) => {
                          const match = name.trim().match(/^([a-zA-Z\s]+?)(\d+)?$/);
                          return match ? [match[1].trim().toUpperCase(), parseInt(match[2] || 0, 10)] : [name.toUpperCase(), 0];
                        };

                        const [aText, aNum] = extractParts(a.name);
                        const [bText, bNum] = extractParts(b.name);

                        if (aText < bText) return -1;
                        if (aText > bText) return 1;

                        return aNum - bNum;
                      })
                      .map((table) => {
                        return (
                          <Col key={table.id} xs={24} sm={12} md={12} lg={8} xl={8}>
                            <Card
                              className={`table-card ${table.statusType}`}
                              onClick={async () => {
                                if (loading) return;
                                try {
                                  setLoading(true);
                                  await handleTable(table);
                                  setSearchInput("");
                                } finally {
                                  setLoading(false);
                                }
                              }}
                              style={{
                                borderRadius: "16px",
                                padding: "22px",
                                height: "170px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                cursor: loading ? "not-allowed" : "pointer",
                                opacity: loading ? 0.6 : 1,
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "1.2em",
                                  fontWeight: 600,
                                  marginBottom: "6px",
                                }}
                              >
                                {table.name}
                              </div>

                              <div
                                style={{
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  marginBottom: "8px",
                                }}
                              >
                                {table.statusType === "ONG" || table.statusType === "OCU"
                                  ? "ORDER PLACED"
                                  : table.statusType === "STD"
                                  ? "SEATED"
                                  : table.statusType === "RES"
                                  ? "RESERVED"
                                  : "AVAILABLE"}
                              </div>

                              {table.statusType === "STD" ||
                                table.statusType === "ONG" ||
                                (table.statusType === "OCU" && (
                                  <div
                                    style={{
                                      fontSize: "1.05em",
                                      marginBottom: "8px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    👥 {table.noOfPersons ?? 0} / {table.noOfPersons ?? 0}
                                  </div>
                                ))}
                              {table.statusType === "OCU" || (table.statusType === "ONG" && <div style={{ fontSize: "1.1em", fontWeight: 600 }}>{table.guestName || ""}</div>)}

                              {table.statusType === "RES" && table.reservedTime && <div style={{ fontSize: "0.95em", marginTop: "6px" }}>{table.reservedTime}</div>}

                              {table.statusType === "OCU" || (table.statusType === "ONG" && table.time && <div style={{ fontSize: "0.95em", marginTop: "6px" }}>{table.time}</div>)}
                            </Card>
                          </Col>
                        );
                      })}
                  </Row> */}
                  {/* <Row gutter={[16, 16]} style={{ rowGap: "11px" }}>
                    {[...tableData]
                      .filter((t) => t.isMergedChild !== "Y") // 👈 hide child tables
                      .sort((a, b) => {
                        const extractParts = (name) => {
                          const match = name.trim().match(/^([a-zA-Z\s]+?)(\d+)?$/);
                          return match ? [match[1].trim().toUpperCase(), parseInt(match[2] || 0, 10)] : [name.toUpperCase(), 0];
                        };

                        const [aText, aNum] = extractParts(a.name);
                        const [bText, bNum] = extractParts(b.name);

                        if (aText < bText) return -1;
                        if (aText > bText) return 1;

                        return aNum - bNum;
                      })
                      .map((table) => {
                        return (
                          <Col key={table.id} xs={24} sm={12} md={12} lg={8} xl={8}>
                            <Card
                              className={`table-card ${table.statusType} ${table.isMergedParent === "Y" ? "MERGED" : ""}`}
                              onClick={async () => {
                                if (loading) return;
                                try {
                                  setLoading(true);
                                  await handleTable(table);
                                  setSearchInput("");
                                } finally {
                                  setLoading(false);
                                }
                              }}
                              style={{
                                borderRadius: "16px",
                                padding: "22px",
                                height: "170px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                cursor: loading ? "not-allowed" : "pointer",
                                opacity: loading ? 0.6 : 1,
                                position: "relative", // for the badge
                              }}
                            >
                              {table.isMergedParent === "Y" && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 8,
                                    right: 12,
                                    padding: "2px 10px",
                                    borderRadius: "7px",
                                    fontSize: 11,
                                    fontWeight: 600,
                                    background: "#2563EB",
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 4,
                                  }}
                                >
                                  <MergeCellsOutlined style={{ fontSize: 12 }} /> Merged
                                </div>
                              )}
                              <div
                                style={{
                                  fontSize: "1.2em",
                                  fontWeight: 600,
                                  marginBottom: "6px",
                                }}
                              >
                                {table.displayName || table.name}
                              </div>

                              <div
                                style={{
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  marginBottom: "8px",
                                }}
                              >
                                {table.statusType === "ONG" || table.statusType === "OCU"
                                  ? "ORDER PLACED"
                                  : table.statusType === "STD"
                                  ? "SEATED"
                                  : table.statusType === "RES"
                                  ? "RESERVED"
                                  : "AVAILABLE"}
                              </div>

                              {table.statusType === "STD" ||
                                table.statusType === "ONG" ||
                                (table.statusType === "OCU" && (
                                  <div
                                    style={{
                                      fontSize: "1.05em",
                                      marginBottom: "8px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    👥 {table.noOfPersons ?? 0} / {table.noOfPersons ?? 0}
                                  </div>
                                ))}
                              {table.statusType === "OCU" || (table.statusType === "ONG" && <div style={{ fontSize: "1.1em", fontWeight: 600 }}>{table.guestName || ""}</div>)}

                              {table.statusType === "RES" && table.reservedTime && <div style={{ fontSize: "0.95em", marginTop: "6px" }}>{table.reservedTime}</div>}

                              {table.statusType === "OCU" || (table.statusType === "ONG" && table.time && <div style={{ fontSize: "0.95em", marginTop: "6px" }}>{table.time}</div>)}
                            </Card>
                          </Col>
                        );
                      })}
                  </Row> */}
                  <div className="table-grid-wrapper" style={{ maxWidth: "1400px", width: "100%", margin: "0 auto" }}>
                    <div
                      className="table-grid"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(8, 1fr)",
                        gap: "12px",
                      }}
                    >
                      {[...allDisplayTables]
                        .filter((t) => !mergedChildIds.has(t.cwrFbTableId) && !splitParentIds.has(t.id))
                        .sort((a, b) => {
                          const extractParts = (name) => {
                            const match = name.trim().match(/^([a-zA-Z\s]+?)(\d+)?$/);
                            return match ? [match[1].trim().toUpperCase(), Number.parseInt(match[2] || 0, 10)] : [name.toUpperCase(), 0];
                          };
                          const [aText, aNum] = extractParts(a.name);
                          const [bText, bNum] = extractParts(b.name);
                          if (aText < bText) return -1;
                          if (aText > bText) return 1;
                          return aNum - bNum;
                        })
                        .map((table) => {
                          const isMerged = Array.isArray(table.merge) && table.merge.length > 0;
                          const isSplitChild = table.isSplitChild === "Y";
                          let displayName = table.name;

                          if (isMerged) {
                            const childNames = table.merge?.map((m) => tableById[m.fbMTableId]?.name).filter(Boolean) || [];
                            if (childNames.length > 0) {
                              displayName = [table.name, ...childNames].join(" + ");
                            }
                          }

                          return (
                            <div key={table.id}>
                              <Card
                                className={`table-card ${table.statusType} ${isMerged ? "MERGED" : ""} ${isSplitChild ? "SPLIT" : ""}`}
                                onClick={async () => {
                                  if (openTableInFlightRef.current || loading) return;
                                  try {
                                    openTableInFlightRef.current = true;
                                    setLoading(true);
                                    await handleTable(table);
                                    setSearchInput("");
                                  } finally {
                                    openTableInFlightRef.current = false;
                                    setLoading(false);
                                  }
                                }}
                                style={{
                                  borderRadius: "14px",
                                  height: "100px",
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textAlign: "center",
                                  cursor: loading ? "not-allowed" : "pointer",
                                  opacity: loading ? 0.6 : 1,
                                  position: "relative",
                                  border: "1px solid #D1D5DB",
                                }}
                              >
                                {/* badges/time — untouched */}
                                {/* {(table.statusType === "STD" || table.statusType === "OCU" || table.statusType === "ONG") && table.startedAt && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 6,
                                      right: 10,
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    <ClockCircleOutlined style={{ marginRight: 5 }} />
                                    {formatElapsed(table.startedAt)}
                                  </div>
                                )} */}
                                {isMerged && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 8,
                                      right: 12,
                                      padding: "2px 10px",
                                      borderRadius: "7px",
                                      fontSize: 11,
                                      fontWeight: 600,
                                      background: "#2563EB",
                                      color: "#fff",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 4,
                                    }}
                                  >
                                    <MergeCellsOutlined style={{ fontSize: 12 }} /> Merged
                                  </div>
                                )}
                                {isSplitChild && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 8,
                                      right: 12,
                                      padding: "2px 10px",
                                      borderRadius: "7px",
                                      fontSize: 11,
                                      fontWeight: 600,
                                      background: "#f4a261",
                                      color: "#fff",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 4,
                                    }}
                                  >
                                    <ExpandAltOutlined style={{ fontSize: 12 }} /> Split
                                  </div>
                                )}

                                {/* content */}
                                <div className="table-card-name" style={{ fontSize: "0.8em", fontWeight: 600, marginBottom: "2px" }}>{displayName}</div>
                                <div className="table-card-status" style={{ fontSize: "0.8em", fontWeight: 500, opacity: 0.8 }}>
                                  {table.statusType === "ONG" || table.statusType === "OCU"
                                    ? "ORDER PLACED"
                                    : table.statusType === "STD"
                                      ? "SEATED"
                                      : table.statusType === "RES"
                                        ? "RESERVED"
                                        : table.statusType === "FSM"
                                          ? "FOOD SERVED"
                                          : table.statusType === "BRQ"
                                            ? "BILL REQUESTED"
                                            : "AVAILABLE"}
                                </div>
                              </Card>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </InfiniteScroll>
              </div>
            </Scrollbars>
            <div
              className="dinein-legend-footer"
              style={{
                width: "100%", // matches the 73% container width
                position: "absolute",
                bottom: 0,
                left: 0,
                background: "#fff",
                height: "8vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 1.2vw", // reduced padding to match screenshot
                boxShadow: "0px -2px 4px rgba(0,0,0,0.1)",
              }}
            >
              {/* LEFT STATUS LEGENDS */}
              <div className="dinein-legend-items" style={{ display: "flex", alignItems: "center", gap: "1.6vw" }}>
                {/* AVAILABLE */}
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ width: 12, height: 12, background: "#E5E7EB", borderRadius: 3 }} />
                  <span style={{ fontSize: "0.9rem" }}>{getMultilingualText("Available")}</span>
                </span>

                {/* RESERVED */}
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ width: 12, height: 12, background: "#FBBF24", borderRadius: 3 }} />
                  <span style={{ fontSize: "0.9rem" }}>{getMultilingualText("Reserved")}</span>
                </span>

                {/* SEATED */}
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ width: 12, height: 12, background: "#93C5FD", borderRadius: 3 }} />
                  <span style={{ fontSize: "0.9rem" }}>{getMultilingualText("Seated")}</span>
                </span>

                {/* ORDER PLACED */}
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ width: 12, height: 12, background: "#7d6d8f", borderRadius: 3 }} />
                  <span style={{ fontSize: "0.9rem" }}>{getMultilingualText("Order Placed")}</span>
                </span>

                {/* FOOD SERVED */}
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ width: 12, height: 12, background: "#BBF7D0", borderRadius: 3 }} />
                  <span style={{ fontSize: "0.9rem" }}>{getMultilingualText("Food Served")}</span>
                </span>

                {/* BILL REQUESTED */}
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ width: 12, height: 12, background: "#FECACA", borderRadius: 3 }} />
                  <span style={{ fontSize: "0.9rem" }}>{getMultilingualText("Bill Requested")}</span>
                </span>
              </div>

              {/* RIGHT BUTTON */}
              {posConfig?.enableTableReservation === "Y" && (
                <Button
                  style={{ backgroundColor: "#2F3856", color: "#fff", borderRadius: "10px", height: "6vh", fontSize: "1em", fontWeight: "500", fontFamily: "Inter" }}
                  onClick={handleReserveTable}
                >
                  {getMultilingualText("Reserve Table")}
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
      <Drawer
        placement="right"
        width="27%"
        rootClassName="table-search-drawer"
        open={isSearchDrawerOpen}
        onClose={() => setIsSearchDrawerOpen(false)}
        title={null}
        closable={false}
        styles={{
          body: {
            padding: 0,
          },
        }}
        maskClosable={true}
      >
        <div className="table-search-drawer-body" style={{ background: "#fff", height: "100vh", fontSize: "1vw", overflow: "hidden" }}>
          <div
            className="table-search-drawer-header"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "1rem 1rem 0.8rem 1rem",
              borderBottom: "1px solid #f0f0f0",
              gap: "1rem",
            }}
          >
            <Input
              placeholder={getMultilingualText("Search here")}
              prefix={<img src={SearchIcon} alt="" style={{ height: "2.4vh", paddingRight: "8px" }} />}
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              suffix={searchInput.length > 0 ? <CloseSquareFilled style={{ fontSize: "20px", color: "#2F3856", cursor: "pointer" }} onClick={() => setSearchInput("")} /> : null}
              style={{
                flex: 1,
                marginRight: "12px",
                borderRadius: "12px",
                margin: 0,
              }}
              className="search-input"
            />

            <img src={closeX} onClick={() => setIsSearchDrawerOpen(false)} style={{ cursor: "pointer", width: "20px", height: "20px" }} alt="close drawer" />
          </div>
          <div style={{ padding: "0 1vw" }}>
            {/* <Input
            placeholder="Search here"
            // prefix={<SearchOutlined />}
            prefix={<img src={SearchIcon} alt="" style={{ paddingLeft: "5px", paddingRight: 0, height: "2.4vh" }} />}
            className="search-input"
          /> */}
          </div>

          <Row className="table-search-tabs-row">
            <Col span={12} style={{ padding: "2vh 0.5vw 1vh 1vw" }}>
              <Button
                style={{
                  backgroundColor: reservedButtonFlag ? "#fff" : "#2F3856",
                  color: reservedButtonFlag ? "#929098" : "#fff",
                  borderRadius: "35px",
                  width: "100%",
                  fontSize: "1em",
                  fontWeight: "500",
                  padding: "1vh",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  height: "auto",
                  lineHeight: "1.5",
                }}
                onClick={() => {
                  setReservedButtonFlag(false);
                  setCurrentTable({});
                }}
              >
                Reserved {reservationList?.filter((res) => res.status == "NEW").length}
                {multilingual && (
                  <span style={{ display: "block", marginTop: "0.5vh" }}>
                    {t("Reserved")} {reservedTablesData.length}
                  </span>
                )}
              </Button>
            </Col>

            <Col span={12} style={{ padding: "2vh 1vw 1vh 0.5vw" }}>
              <Button
                style={{
                  backgroundColor: !reservedButtonFlag ? "#fff" : "#2F3856",
                  color: !reservedButtonFlag ? "#929098" : "#fff",
                  borderRadius: "35px",
                  width: "100%",
                  fontSize: "1em",
                  fontWeight: "500",
                  padding: "1vh",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  height: "auto",
                  lineHeight: "1.5",
                }}
                onClick={() => {
                  setReservedButtonFlag(true);
                  setCurrentTable({});
                }}
              >
                Checked-in {occupiedDataTablesData.length}
                {multilingual && (
                  <span style={{ display: "block", marginTop: "0.5vh" }}>
                    {t("Checked-in")} {occupiedDataTablesData.length}
                  </span>
                )}
              </Button>
            </Col>
          </Row>

          <Scrollbars autoHide className="table-search-scrollbar" style={{ height: "66vh" }}>
            <div>
              {reservedButtonFlag
                ? occupiedDataTablesData
                    ?.filter(
                      (occupiedData) =>
                        occupiedData.name?.toLowerCase().includes(searchInput.toLowerCase()) || occupiedData.guestName?.toLowerCase().includes(searchInput.toLowerCase())
                    )
                    ?.map((occupiedData) => {
                      const isSelected = occupiedData.name === currentTable?.name;
                      return (
                        <Card
                          style={{
                            width: "100%",
                            border: "none",
                          }}
                          styles={{
                            body: {
                              padding: "1vh",
                            },
                          }}
                          onClick={() => setCurrentTable(occupiedData)}
                        >
                          <div
                            className="table-search-row"
                            style={{
                              backgroundColor: isSelected ? "#9290984D" : "#fff",
                              borderRadius: 25,
                              display: "flex",
                              alignItems: "center",
                              height: "7vh",
                              fontSize: "1vw",
                              cursor: "pointer",
                            }}
                          >
                            <Text strong className="table-search-row-name" style={{ textAlign: "left", width: "18vw" }}>
                              <span
                                style={{
                                  paddingRight: "2vw",
                                  paddingLeft: "1vw",
                                  fontSize: "1em",
                                  color: "#0F0718",
                                  fontWeight: 500,
                                }}
                              >
                                {occupiedData?.name}
                              </span>{" "}
                              <span>{occupiedData?.guestName}</span>
                            </Text>
                            <Text
                              className="table-search-row-persons"
                              style={{
                                textAlign: "right",
                                fontSize: "1em",
                                color: "#929098",
                                fontWeight: 500,
                              }}
                            >
                              {occupiedData.noOfPersons} Persons
                            </Text>
                          </div>
                        </Card>
                      );
                    })
                : reservationList
                    ?.filter(
                      (res) =>
                        res.status == "NEW" && // 🔥 ONLY SHOW NEW RESERVATIONS
                        (res.name?.toLowerCase().includes(searchInput.toLowerCase()) || res.tableId?.toLowerCase().includes(searchInput.toLowerCase()))
                    )
                    ?.map((res) => {
                      const isSelected = res.id === currentTable?.id;
                      return (
                        <Card
                          key={res.id}
                          style={{ width: "100%", border: "none", cursor: "pointer" }}
                          styles={{ body: { padding: "1vh" } }}
                          onClick={async () => {
                            handleKeyvalue("4"); // 🔥 Navigate to Reservations Page
                            setReservationsBlank(true); // 🔥 Enable reservations UI
                            await loadReservations(); // 🔥 Reload reservations from server

                            const list = await loadWaitlistForUI(); // (Your existing behavior)
                            setWaitlistList(list);

                            setCurrentTable(res); // Optional highlight
                          }}
                        >
                          <div
                            className="table-search-row"
                            style={{
                              backgroundColor: isSelected ? "#9290984D" : "#fff",
                              borderRadius: 25,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              height: "7vh",
                              padding: "0 1vw",
                            }}
                          >
                            {/* LEFT SIDE — NAME */}
                            <Text strong style={{ fontSize: "1em", color: "#0F0718" }}>
                              {res.name}
                            </Text>

                            {/* RIGHT SIDE — PERSON COUNT */}
                            <Text style={{ fontSize: "1em", color: "#929098", fontWeight: 500 }}>{res.guests} Persons</Text>
                          </div>
                        </Card>
                      );
                    })}
            </div>
          </Scrollbars>

          {(reservedButtonFlag || reservedTablesData.length > 0) && currentTable?.name && (
            <Row
              className="table-search-footer-row"
              style={{
                paddingTop: "9vh",
                display: "flex",
                justifyContent: "space-between",
                display: currentTable.name ? "flex" : "none",
              }}
            >
              {!matchedRep && (
                <Col
                  span={12}
                  style={{
                    padding: "0 0.5vw 0 1vw",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <Button
                    style={{
                      background: "#fff",
                      color: "#2F3856",
                      borderRadius: "10px",
                      width: "100%",
                      fontSize: "1em",
                      fontWeight: "500",
                      height: "6vh",
                    }}
                    onClick={() => handleCancel(currentTable)}
                  >
                    Cancel
                  </Button>
                </Col>
              )}
              <Col
                span={matchedRep ? 24 : 12}
                style={{
                  padding: matchedRep ? "0 1vw" : "0 1vw 0 0.5vw",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  disabled={loading}
                  loading={loading}
                  onClick={async () => {
                    if (openTableInFlightRef.current || loading) return;
                    try {
                      openTableInFlightRef.current = true;
                      setLoading(true);
                      await handleTable(currentTable);
                      setSearchInput("");
                    } finally {
                      openTableInFlightRef.current = false;
                      setLoading(false);
                    }
                  }}
                  style={{
                    background: loading ? "#999" : "#2F3856",
                    color: "#fff",
                    borderRadius: "10px",
                    width: "100%",
                    fontSize: "1em",
                    fontWeight: "500",
                    height: "6vh",
                  }}
                >
                  Place order
                </Button>
              </Col>
            </Row>
          )}
        </div>
      </Drawer>
      <TableFeatures
        reserveModalOpen={reserveModalOpen}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        mergeDrawerOpen={mergeDrawerOpen}
        closeMergeDrawer={() => setMergeDrawerOpen(false)}
        waitlistDrawerOpen={waitlistDrawerOpen}
        setWaitlistDrawerOpen={setWaitlistDrawerOpen}
        loadWaitlistForUI={loadWaitlistForUI}
        waitlistTab={waitlistTab}
        setWaitlistTab={setWaitlistTab}
        saveToWaitlist={saveToWaitlist}
        validateWaitlistForm={validateWaitlistForm}
        waitlistForm={waitlistForm}
        setWaitlistForm={setWaitlistForm}
        waitlistErrors={waitlistErrors}
        setWaitlistErrors={setWaitlistErrors}
        waitlistList={waitlistList}
        setWaitlistList={setWaitlistList}
        getWaitlist={getWaitlist}
        reservationList={reservationList}
        setReservationList={setReservationList}
        errors={errors}
        setErrors={setErrors}
        form={form}
        setForm={setForm}
        selectData={selectData}
        // setSelectData={setSelectData}
        setSelectData={setSelectData}
        tableList={tableList}
        setTableList={setTableList}
        setReserveModalOpen={setReserveModalOpen}
        setTableCards={setTableCards}
        setOcupiedTablesData={setOcupiedTablesData}
        setReservedTablesData={setReservedTablesData}
        setMainTableData={setMainTableData}
        handleTable={handleTable}
        loadReservations={loadReservations}
        reservationsBlank={reservationsBlank}
        setReservationsBlank={setReservationsBlank}
        handleReserveTable={handleReserveTable}
        handleReserveTableDetails={handleReserveTableDetails}
        setNumberOfPersons={setNumberOfPersons}
      />
    </>
  );
};

export default TableLayout;
